/**
 * /admin/access - retired. Re-pointed at the access-requests queue (design R-Q8).
 *
 * The access roster itself merged into /admin/users, so this used to redirect
 * there. But the name is what people typed when they were looking for the
 * application queue, and that queue now has its own route - so the bookmark
 * lands on the page whose name it matches. The old page carried no URL state,
 * so nothing maps across.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/access')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/access-requests', replace: true });
  },
});
